import React from "react";
import { Box, Button, Grid, Paper, Typography } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import ChatIcon from "@material-ui/icons/Chat";
import MenuBookIcon from "@material-ui/icons/MenuBook";

const NOTEBOOK_LM_URL =
  "https://notebooklm.google.com/notebook/45abe956-fee7-420e-a30c-ca16f2b91cd9";

const CHATGPT_SETUP_URL = "https://tasteck.tech/integrations/chatgpt-setup";

const AISupport: React.FC = () => {
  const openNotebookLM = () => {
    window.open(NOTEBOOK_LM_URL, "_blank", "noopener,noreferrer");
  };

  const openChatGPTSetup = () => {
    window.open(CHATGPT_SETUP_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Box padding={4} style={{ maxWidth: 1200, margin: "0 auto" }}>
      <Typography
        variant="h4"
        align="center"
        style={{ fontWeight: "bold", marginBottom: 8 }}
      >
        AIサポート
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        style={{ marginBottom: 32 }}
      >
        マニュアル質問は NotebookLM、 実データ操作は ChatGPT 連携でどうぞ。
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper
            elevation={3}
            style={{
              padding: 32,
              height: "100%",
              textAlign: "center",
              background:
                "linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)",
              boxSizing: "border-box",
            }}
          >
            <HelpOutlineIcon style={{ fontSize: 56, color: "#1976d2" }} />
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8 }}
            >
              マニュアル AI
            </Typography>
            <Typography
              variant="caption"
              display="block"
              color="textSecondary"
              style={{ marginBottom: 12 }}
            >
              Google NotebookLM
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: 20, minHeight: 60 }}
            >
              操作方法や設定のわからないことを、 AI にチャットで質問できます。
              <br />
              マニュアルの内容を元に、 24時間いつでも回答します。
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<OpenInNewIcon />}
              onClick={openNotebookLM}
              style={{ padding: "10px 24px", fontSize: 15 }}
            >
              AIチャットを開く
            </Button>
            <Typography
              variant="caption"
              display="block"
              color="textSecondary"
              style={{ marginTop: 12 }}
            >
              新しいタブで開きます
            </Typography>

            <Box
              style={{
                marginTop: 24,
                padding: 16,
                backgroundColor: "#fffef5",
                borderLeft: "4px solid #ffa726",
                textAlign: "left",
              }}
            >
              <Box display="flex" alignItems="center" style={{ gap: 8, marginBottom: 6 }}>
                <MenuBookIcon style={{ color: "#ffa726", fontSize: 18 }} />
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  よくある質問例
                </Typography>
              </Box>
              <Box component="ul" style={{ margin: 0, paddingLeft: 18 }}>
                <li>
                  <Typography variant="body2">予約の新規登録方法は？</Typography>
                </li>
                <li>
                  <Typography variant="body2">キャストの登録方法は？</Typography>
                </li>
                <li>
                  <Typography variant="body2">LINE連携の設定方法は？</Typography>
                </li>
                <li>
                  <Typography variant="body2">精算書の出力方法は？</Typography>
                </li>
                <li>
                  <Typography variant="body2">プラン変更はどこから？</Typography>
                </li>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper
            elevation={3}
            style={{
              padding: 32,
              height: "100%",
              textAlign: "center",
              background:
                "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
              boxSizing: "border-box",
            }}
          >
            <ChatIcon style={{ fontSize: 56, color: "#10b981" }} />
            <Box
              display="inline-block"
              style={{
                marginLeft: 8,
                padding: "2px 8px",
                fontSize: 11,
                fontWeight: "bold",
                color: "#10b981",
                backgroundColor: "#d1fae5",
                borderRadius: 12,
                verticalAlign: "middle",
              }}
            >
              NEW
            </Box>
            <Typography
              variant="h5"
              style={{ fontWeight: "bold", marginTop: 8, marginBottom: 8 }}
            >
              ChatGPT 連携 (MCP)
            </Typography>
            <Typography
              variant="caption"
              display="block"
              color="textSecondary"
              style={{ marginBottom: 12 }}
            >
              ChatGPT Plus / Pro / Business 対応
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: 20, minHeight: 60 }}
            >
              ChatGPT に LINE / メール予約をコピペするだけで、 tasteck の受注画面に自動登録。
              <br />
              経営者の AI 使いをスーパーパワー化。
            </Typography>
            <Button
              variant="contained"
              size="large"
              startIcon={<OpenInNewIcon />}
              onClick={openChatGPTSetup}
              style={{
                padding: "10px 24px",
                fontSize: 15,
                backgroundColor: "#10b981",
                color: "#fff",
              }}
            >
              連携セットアップを見る
            </Button>
            <Typography
              variant="caption"
              display="block"
              color="textSecondary"
              style={{ marginTop: 12 }}
            >
              3 ステップ・約 2 分・OAuth 2.1 認証
            </Typography>

            <Box
              style={{
                marginTop: 24,
                padding: 16,
                backgroundColor: "#ecfdf5",
                borderLeft: "4px solid #10b981",
                textAlign: "left",
              }}
            >
              <Box display="flex" alignItems="center" style={{ gap: 8, marginBottom: 6 }}>
                <ChatIcon style={{ color: "#10b981", fontSize: 18 }} />
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  ChatGPT 連携でできること
                </Typography>
              </Box>
              <Box component="ul" style={{ margin: 0, paddingLeft: 18 }}>
                <li>
                  <Typography variant="body2">
                    LINE 予約文をコピペ → 受注自動登録
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    「田中さんの先月の予約」 → 履歴照会
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    キャスト / シフト / 顧客の新規登録
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    口語・略語・typo を自動推定 (Phase 2B)
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    22 tool 標準搭載・全業務 cover
                  </Typography>
                </li>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AISupport;
